import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { GlobalAlert } from "./components/common/GlobalAlert";
import useCamera from "./hooks/useCamera";
import { useStore } from "./hooks/useStore";
import { useTranslation } from "./hooks/useTranslation";
import { ModalExpireSession } from "./layout/ModalExpireSession/ModalExpireSession";
import HttpInterceptor from "./passapp-sdk/utils/HttpInterceptor";
import { getResidentsOfCountry } from "./redux/actions/authActions";
import ProtectedRoutes from "./routes/ProtectedRoutes";
import { RoutePaths } from "./utils/Items";
import { loadResources } from "./utils/Tesseract";
import Dashboard from "./views/Dashboard/Dashboard";
import Login from "./views/Login/Login";
import RegistroIngreso from "./views/LogisticPark/RegistroIngreso/RegistroIngreso";
import DateFnsUtils from "@date-io/date-fns";
import { es, pt, enUS } from "date-fns/locale";
import LogisticParkDashboard from "./views/LogisticPark/LogisticParkDashboard";
import { RegistroIngresoSessionProvider } from "./views/LogisticPark/RegistroIngreso/session/RegistroIngresoSessionContext";
import Reservations from "./views/Reservations/Reservations";
import ReservationScanner from "./views/Reservations/ReservationScanner/ReservationScanner";
import ReservationResult from "./views/Reservations/ReservationResult/ReservationResult";

function App() {
  const dispatch = useDispatch();
  const { authStore } = useStore();
  const { getListOfCameras } = useCamera();
  const { changeLanguage } = useTranslation();
  HttpInterceptor(dispatch);

  useEffect(() => {
    if (authStore.residents) {
      getResidentsOfCountry(authStore.token, dispatch);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(authStore.residents)]);

  useEffect(() => {
    loadResources();
    getListOfCameras();
    changeLanguage(authStore.lang);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const localeDateFNS = (lang: string) => {
    switch (lang) {
      case "es_ES":
        return es;
      case "en_US":
        return enUS;
      case "pt_BR":
        return pt;
      default:
        return es;
    }
  };

  return (
    <RegistroIngresoSessionProvider>
      <MuiPickersUtilsProvider locale={localeDateFNS(authStore.lang)} utils={DateFnsUtils}>
        <div style={{ height: "100vh" }}>
          <Router>
            <Switch>
              <Route path={RoutePaths.Login} exact component={Login} />
              <ProtectedRoutes path={RoutePaths.Reservations} exact component={Reservations} />
              <ProtectedRoutes
                path={RoutePaths.ReservationScan}
                exact
                component={ReservationScanner}
              />
              <ProtectedRoutes
                path={RoutePaths.ReservationResult}
                exact
                component={ReservationResult}
              />
              <ProtectedRoutes path={RoutePaths.Incomes} exact component={RegistroIngreso} />
              <ProtectedRoutes path={RoutePaths.LogisticPark} component={LogisticParkDashboard} />
              <ProtectedRoutes path={RoutePaths.Dashboard} component={Dashboard} />
            </Switch>
          </Router>
          <ModalExpireSession />
          <GlobalAlert />
        </div>
      </MuiPickersUtilsProvider>
    </RegistroIngresoSessionProvider>
  );
}

export default App;
